import {
    SET_ASSET_NUMBER_VALUE,
    SET_TRANSFER_ASSET_DETAILS,
    SET_ASSET_ERROR,
    SET_REACTIVATION_ASSET_DETAILS,
    SET_FLEET_ASSET_VALIDATION,
    SET_FLEET_Item_Id
} from "./AssetNumberType";

const initialState = {
    assetNumberValue: [],
    assetError: "",
    assetValidation: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_NUMBER_VALUE:
            return {
                ...state,
                assetNumberValue: action.assetNumberValue,
            };
        case SET_TRANSFER_ASSET_DETAILS:
            return {
                ...state,
                assetDetails: action.assetDetail
            }
        case SET_ASSET_ERROR:
            return {
                ...state,
                assetError: action.error
            }
        case SET_REACTIVATION_ASSET_DETAILS:
            return {
                ...state,
                reacivationAssetDetails: action.assetDetail
            }
        case SET_FLEET_ASSET_VALIDATION:
            return {
                ...state,
                assetValidation: action.assetValidation
            }  
        case SET_FLEET_Item_Id:
            return {
                ...state,
                itemId: action.itemId
            } 
        default:
            return state;
    }
};

export default reducer;
